import { Node } from 'slate';

import { CellEntry, TablePosition } from '../types';
import { getTableById } from './getTableById';
import { isCellHeading } from './isCellHeading';

/**
 * We say: a row is heading if this row has more than 1 cell heading
 */
export function isRowHeading(editor: any, id: string, rowIndex: number = TablePosition.FIRST_ROW) {
  const entry = getTableById(editor, id);

  if (!entry) return false;

  const [table] = entry;
  const cells: CellEntry[] = Array.from(Node.children(table, [rowIndex])) as CellEntry[];

  if (cells.length === 1) {
    const [[cell]] = cells;
    return isCellHeading(cell) && cell.colSpan > 1;
  }

  let numberOfCellHeading = 0;

  for (const [cell] of cells) {
    if (isCellHeading(cell)) {
      numberOfCellHeading += 1;
    }
  }

  return numberOfCellHeading > 1;
}
